const GOOGLE_CLIENT_ID: string = '521788314635-qu6b44j30jvmp4379b015ifg74lvl2ir.apps.googleusercontent.com';
const CACHED_KEY       = 'web_google_id';
const REDIRECT_URI     = window.location.origin;

function parseJwtPayload( token: string ): Record<string, unknown>
{
  try
  {
    return JSON.parse( atob( token.split( '.' )[ 1 ].replace( /-/g, '+' ).replace( /_/g, '/' ) ) );
  }
  catch
  {
    return {};
  }
}

function openGooglePopup(): Promise<string>
{
  return new Promise( ( resolve, reject ) =>
  {
    const nonce = crypto.randomUUID();

    const params = new URLSearchParams( {
      client_id:     GOOGLE_CLIENT_ID,
      redirect_uri:  REDIRECT_URI,
      response_type: 'id_token',
      scope:         'openid email',
      nonce,
    } );

    console.log( '[GoogleWebSignIn] redirect_uri:', REDIRECT_URI );

    const popup = window.open(
      `https://accounts.google.com/o/oauth2/v2/auth?${ params }`,
      'google-signin',
      'width=500,height=600,left=200,top=100'
    );

    if ( !popup )
    {
      reject( new Error( 'Popup blocked' ) );
      return;
    }

    const pollTimer = setInterval( () =>
    {
      try
      {
        const hash = popup.location.hash;
        if ( !hash ) return;

        clearInterval( pollTimer );
        clearInterval( closeTimer );
        popup.close();

        const token = new URLSearchParams( hash.slice( 1 ) ).get( 'id_token' );
        if ( !token )
        {
          reject( new Error( 'No id_token in response' ) );
          return;
        }

        const payload = parseJwtPayload( token );

        if ( payload.nonce !== nonce )
        {
          reject( new Error( 'Nonce mismatch' ) );
          return;
        }

        const now = Math.floor( Date.now() / 1000 );
        if ( typeof payload.exp === 'number' && payload.exp < now )
        {
          reject( new Error( 'Token expired' ) );
          return;
        }

        resolve( token );
      }
      catch
      {
        // Still on accounts.google.com — cross-origin, keep polling
      }
    }, 300 );

    const closeTimer = setInterval( () =>
    {
      if ( popup.closed )
      {
        clearInterval( pollTimer );
        clearInterval( closeTimer );
        reject( new Error( 'Closed by user' ) );
      }
    }, 500 );
  } );
}

export const GoogleWebSignIn = {
  isAvailable(): boolean
  {
    return GOOGLE_CLIENT_ID !== '';
  },

  getCachedId(): string | null
  {
    return localStorage.getItem( CACHED_KEY );
  },

  setCachedId( id: string ): void
  {
    localStorage.setItem( CACHED_KEY, id );
  },

  async signIn(): Promise<{ idToken: string }>
  {
    const idToken = await openGooglePopup();
    return { idToken };
  },

  signOut(): void
  {
    localStorage.removeItem( CACHED_KEY );
  },

  getAndroidId(): null
  {
    return null;
  },
};
